module.exports = __webpack_public_path__ + "img/match--type2_img2.57d5aba9.png";